import { defineStore } from 'pinia'
import type { IAccountCityWarehouses, IAccountWarehouse, TPriority } from "~/shared/interfaces/account/sortingWarehouses"

interface ISortingWarehousesState {
  cityWarehouses: IAccountCityWarehouses[]
}

const useWarehousesStore = defineStore('sorting-warehouses', {
  state: (): ISortingWarehousesState => ({
    cityWarehouses: [],
  }),
  getters: {
    getWarehousesSortedByOrder(): IAccountCityWarehouses[] {
      if (this.cityWarehouses.length) {
        const cityWarehouses = [...this.cityWarehouses];

        cityWarehouses.sort((firstCity, secondCity) => firstCity.cityOrderWeight - secondCity.cityOrderWeight)

        cityWarehouses.forEach(({ warehouses }) => {
          warehouses.sort((firstWarehouse, secondWarehouse) => firstWarehouse.orderWeight - secondWarehouse.orderWeight);
        })

        cityWarehouses.forEach(({ warehouses }) => {
          warehouses.forEach((warehouse, index) => warehouse.orderWeight = index + 1)
        })


        return cityWarehouses;
      }

      return [];
    }
  },
  actions: {
    setCityWarehousesList(cityWarehouses: IAccountCityWarehouses[]) {
      this.cityWarehouses = cityWarehouses;
    },
    setWarehousePriority(warehouse: IAccountWarehouse, citySlug: string, priorityTo: TPriority) {
      const city = this.cityWarehouses.find(cityWarehouse => cityWarehouse.citySlug == citySlug)
      let warehouses = city?.warehouses;
      const warehouseIndex = warehouses?.findIndex(el => el.id === warehouse.id)

      if (warehouses && warehouseIndex !== undefined && warehouseIndex >= 0) {
        if (priorityTo === 'up') {
          [warehouses[warehouseIndex - 1], warehouses[warehouseIndex]] = [warehouses[warehouseIndex], warehouses[warehouseIndex - 1]]
        } else {
          [warehouses[warehouseIndex], warehouses[warehouseIndex + 1]] = [warehouses[warehouseIndex + 1], warehouses[warehouseIndex]]
        }

        if (city?.warehouses) {
          warehouses.forEach((warehouse, index) => warehouse.orderWeight = index + 1)
          city.warehouses = warehouses
        }
      }
    },
    setWarehouseShowStatus(citySlug: string, warehouseId: number, status: boolean) {
      const city = this.cityWarehouses.find(cityItem => cityItem.citySlug == citySlug);

      if (city) {
        const warehouse = city.warehouses.find(warehouse => warehouse.id == warehouseId);

        if (warehouse) {
          warehouse.isShow = status;
        }
      }
    },
    setCityOrder(newIndex: number, oldIndex: number, needReplace?: boolean, raiseToTop?: boolean) {
      if(raiseToTop) {
        const cityWarehouses = this.cityWarehouses[oldIndex]
        this.cityWarehouses.splice(oldIndex, 1)
        this.cityWarehouses.unshift(cityWarehouses)
      }
      if (needReplace) {
        [this.cityWarehouses[oldIndex], this.cityWarehouses[newIndex]] = [this.cityWarehouses[newIndex], this.cityWarehouses[oldIndex]];
      }

      this.cityWarehouses.forEach((cityInfo, index) => {
        cityInfo.cityOrderWeight = index;
      })
    },
  }
})

export default useWarehousesStore;
